import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from '../../services/general.service';


@Component({
  selector: 'mapbox',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit {
  map: mapboxgl.Map;
  style = 'mapbox://styles/mapbox/streets-v11';

  @Input() zoom : number = 15;
  @Input() options : any = {};
  @Input() disabled : boolean = false;

  @Output() callback = new EventEmitter();

  _address : any = {};
  _latitude : number = 0;
  _longitude : number = 0;

  userDrag = false;

  markerFound:any = null;
  pinFound = false;

  private marker: mapboxgl.Marker = null;

  constructor(  
    private http: HttpClient,
    private gs: GeneralService
    ) { }

  ngAfterViewInit() {
    Object.getOwnPropertyDescriptor(mapboxgl, "accessToken").set(environment.mapbox.accessToken);

    this.load();
  }

  load(){
    if(this.map)
      this.map.remove();

    this.map = new mapboxgl.Map({
      container: 'map',
      style: this.style, 
      zoom: this.zoom,
      maxZoom : 17,
    });
    let fit = 0.000005;
    if(this._longitude && this._latitude)
      this.addMarker(new mapboxgl.LngLat(this._longitude, this._latitude),true,null,fit);

    this.map.addControl(new mapboxgl.NavigationControl());
  }

  addMarker(point : mapboxgl.LngLat, setCenter:Boolean = false, bbox:any = null, fit = 0.01){
    if(this.marker !== null)
      this.marker.remove();

    this.marker = new mapboxgl.Marker({
      draggable: this.options.drag != undefined && this.options.drag && !this.disabled
    })
    .setLngLat(point)
    .addTo(this.map);

    if(this.options.drag != undefined){
      this.marker
        .on('dragend',() => {
          if(this.disabled)
            return;

          this.userDrag = true;
          var lnglat = this.marker.getLngLat();
          lnglat['user'] = true;
          this._latitude = lnglat.lat;
          this._longitude = lnglat.lng;
          this.callback.emit(lnglat);
        });

      //this.callback.emit(point);
    }

    if(setCenter)
      this.map.setCenter([point.lng,point.lat]).fitBounds(bbox? bbox : [point.lng + fit,point.lat+fit,point.lng-fit,point.lat-fit]);
  }

  @Input()
  set latitude(latitude: any) {
    this._latitude = latitude;
    //if(latitude)      this.userDrag = true;
  }
  @Input()
  set longitude(longitude: any) {
    this._longitude = longitude;
    //if(longitude)      this.userDrag = true;
  }

  get address(): any {
    return this._address;
  }
  
  @Input()
  set address(address: any) {
    this._address = address;
    this.search(this._address);
  }

  search(address:any = {}){
    
    if(this.map == undefined)
      return;

    var searchText = '';
    var fit = 0.01;
    

    if(address.street !== null)
      searchText += address.street;
     
    if(address.number !== null){
      searchText += ' '+address.number+', ';
      fit = 0.000005;
    }

    searchText += address.street !== null && address.number === null? ', ' : '';
      
    if(address.city !== null)
      searchText += address.city+', ';

    if(address.state !== null)
      searchText += address.state+', ';
      
    searchText += address.country !== null? address.country : 'Brazil';

      //if(address.zipcode))        searchText += ' '+address.zipcode;
    
    this.http.get('https://api.tiles.mapbox.com/v4/geocode/mapbox.places/' + searchText + '.json?access_token=' + environment.mapbox.accessToken)
    .toPromise()
      .then(res => {
        if(res['features'] !== undefined && !!res['features'].length){
          var fres = res['features'][0];
          this.markerFound = {
            lng : fres['center'][0],
            lat : fres['center'][1],
            bbox : fres['bbox'] != undefined? fres['bbox'] : null,
            fit: fit
          };

          if(!this._latitude || !this._longitude || !this.userDrag)
            this.updatePin(!this.userDrag);
          else
            this.pinFound = true;

        }
      })
      .catch(err => this.gs.error(err));
  }

  updatePin(set = false){
    let lnglat = new mapboxgl.LngLat(this.markerFound.lng,this.markerFound.lat);
    this.addMarker(lnglat,true, this.markerFound.bbox,this.markerFound.fit);
    this.pinFound = false;
    if(set){

      this._longitude = this.markerFound.lng;
      this._latitude = this.markerFound.lat;
      if(this.userDrag)
        lnglat['user'] = true;

      this.callback.emit(lnglat);
    }
  }
}